<script lang="ts">
import { computed, defineComponent, onMounted, ref } from "vue";
import cookieUtils from "@/businesslogic/utils/cookieUtils";
import GeschuetzterRouterLink from "@/components/GeschuetzterRouterLink.vue";
import MaklerDatenService from "@/businesslogic/services/MaklerDatenService";
import Logger from "js-logger";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "Home",
  components: { GeschuetzterRouterLink },
  setup() {
    const { setCookie, setBase64Cookie } = cookieUtils();

    const piniaStore = useFormStore();

    const channel = ref("");
    const campagne = ref("");

    const vid = ref("");
    const gev_prtn = ref("");
    const gev_prms = ref("");
    const gev_ref = ref("");
    const gev_lp = ref("");
    const s_id = ref("");

    const ausgewaehlteVermittlernummer = ref("");
    const vermittlernummern = ref([]);

    const vermittlerId = ref("");
    const externeReferenz = ref("");

    const setzeCookies = () => {
      Logger.debug(
        "values",
        channel.value,
        campagne.value,
        vid.value,
        gev_prtn.value,
        gev_prms.value,
        gev_ref.value,
        gev_lp.value,
        s_id.value,
      );
      setCookie("gevchannel", channel.value);
      setCookie("gevcampagne", campagne.value);
      setCookie("Vid", vid.value);
      setCookie("gev_prtn", gev_prtn.value);
      setCookie("gev_prms", gev_prms.value);
      setCookie("gev_ref", gev_ref.value);
      setCookie("gev_lp", gev_lp.value);
      setCookie("s_id", s_id.value);
    };

    const maklerLinkUrl = (sparte: string) => {
      return (
        "/makler-tarifrechner/" +
        sparte +
        "/?vermittlerId=" +
        vermittlerId.value +
        "&externereferenz=" +
        externeReferenz.value
      );
    };

    const maklerStreckeUrlFuerSparteUndVermittlernummer = (sparte: string) => {
      if (ausgewaehlteVermittlernummer.value !== "") {
        return sparte + "?vermittlerNummer=" + ausgewaehlteVermittlernummer.value;
      }
      return sparte;
    };

    const vermittlernummerHinweistext = computed(() => {
      if (vermittlernummern.value.length === 0) {
        return "(Nicht eingeloggt oder Vermittlernummer fehlt)";
      } else {
        return ausgewaehlteVermittlernummer.value === ""
          ? "(Bitte Vermittlernummer auswählen)"
          : "(Vermittlernr.: " + ausgewaehlteVermittlernummer.value + ")";
      }
    });

    onMounted(() => {
      piniaStore.resetState();
      setBase64Cookie("tarifrechner-init");
      MaklerDatenService.vermittlerNummernDesMaklers()
        .then((res) => {
          if (res.status == 200) {
            if (res.data.includes(";")) {
              vermittlernummern.value = res.data.split(";");
            } else {
              vermittlernummern.value = res.data;
            }
          }
        })
        .catch((e) => {
          Logger.log("Fehler beim initilisieren der Vermittlernummer.", e);
        });
    });

    return {
      setzeCookies,
      channel,
      campagne,
      vid,
      gev_prtn,
      gev_prms,
      gev_ref,
      gev_lp,
      s_id,
      ausgewaehlteVermittlernummer,
      maklerStreckeUrlFuerSparteUndVermittlernummer,
      vermittlernummern,
      vermittlernummerHinweistext,
      maklerLinkUrl,
      vermittlerId,
      externeReferenz,
    };
  },
});
</script>

<template>
  <div class="container">
    <div class="item">
      <h1>PHV</h1>
      <ul>
        <li>
          <geschuetzter-router-link to="/phv">Direkt</geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/phv')"
            >Makler {{ vermittlernummerHinweistext }}
          </geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerLinkUrl('phv')">Makler-Link</geschuetzter-router-link>
        </li>
      </ul>
    </div>

    <div class="item">
      <h1>PHV 2020</h1>
      <ul>
        <li>
          <geschuetzter-router-link to="/phv2020">Direkt</geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/phv2020')"
            >Makler {{ vermittlernummerHinweistext }}
          </geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerLinkUrl('phv2020')">Makler-Link</geschuetzter-router-link>
        </li>
      </ul>
    </div>

    <div class="item">
      <h1>VGV</h1>
      <ul>
        <li>
          <geschuetzter-router-link to="/vgv">Direkt</geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/vgv')"
            >Makler {{ vermittlernummerHinweistext }}
          </geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerLinkUrl('vgv')">Makler-Link</geschuetzter-router-link>
        </li>
      </ul>
    </div>

    <div class="item">
      <h1>VHV</h1>
      <ul>
        <li>
          <geschuetzter-router-link to="/vhv">Direkt</geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/vhv')"
            >Makler {{ vermittlernummerHinweistext }}
          </geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerLinkUrl('vhv')">Makler-Link</geschuetzter-router-link>
        </li>
      </ul>
    </div>

    <div class="item">
      <h1>BL</h1>
      <ul>
        <li>
          <geschuetzter-router-link to="/bl">Direkt</geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/bl')"
            >Makler {{ vermittlernummerHinweistext }}
          </geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerLinkUrl('bl')">Makler-Link</geschuetzter-router-link>
        </li>
      </ul>
    </div>

    <div class="item">
      <h1>BH</h1>
      <ul>
        <li>
          <geschuetzter-router-link to="/bh">Direkt</geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/bh')"
            >Makler {{ vermittlernummerHinweistext }}
          </geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerLinkUrl('bh')">Makler-Link</geschuetzter-router-link>
        </li>
      </ul>
    </div>

    <div class="item">
      <h1>HG</h1>
      <ul>
        <li>
          <geschuetzter-router-link to="/hg">Direkt</geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/hg')"
            >Makler {{ vermittlernummerHinweistext }}
          </geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerLinkUrl('hg')">Makler-Link</geschuetzter-router-link>
        </li>
      </ul>
    </div>
    <div class="item">
      <h1>FH</h1>
      <ul>
        <li>
          <geschuetzter-router-link to="/fh">Direkt</geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerStreckeUrlFuerSparteUndVermittlernummer('/makler/fh')"
            >Makler {{ vermittlernummerHinweistext }}
          </geschuetzter-router-link>
        </li>
        <li>
          <geschuetzter-router-link :to="maklerLinkUrl('fh')">Makler-Link</geschuetzter-router-link>
        </li>
      </ul>
    </div>

    <div class="cookies">
      <h1>Cookies</h1>
      <form novalidate @submit.prevent="setzeCookies">
        <p>
          <label for="channel">GEV Channel</label>&nbsp;
          <input type="text" id="channel" v-model="channel" />
        </p>

        <p>
          <label for="campagne">GEV Campagne</label>&nbsp;
          <input type="text" id="campagne" v-model="campagne" />
        </p>

        <p>
          <label for="vid">Vid</label>&nbsp;
          <input type="text" id="vid" v-model="vid" />
        </p>

        <p>
          <label for="gev_prtn">GEV Prtn</label>&nbsp;
          <input type="text" id="gev_prtn" v-model="gev_prtn" />
        </p>

        <p>
          <label for="gev_prms">GEV Prms</label>&nbsp;
          <input type="text" id="gev_prms" v-model="gev_prms" />
        </p>

        <p>
          <label for="gev_ref">GEV Ref</label>&nbsp;
          <input type="text" id="gev_ref" v-model="gev_ref" />
        </p>

        <p>
          <label for="gev_lp">GEV Lp</label>&nbsp;
          <input type="text" id="gev_lp" v-model="gev_lp" />
        </p>

        <p>
          <label for="s_id">FinanceAds s_id</label>&nbsp;
          <input type="text" id="s_id" v-model="s_id" />
        </p>

        <button type="submit">Cookies setzen</button>
      </form>
    </div>

    <div class="cookies">
      <h1>Makler</h1>

      <h2>Makler-Portal</h2>

      <p>
        <label for="vermittlernummerSelect">Vermittlernummer </label>
        <select id="vermittlernummerSelect" v-model="ausgewaehlteVermittlernummer">
          <option selected="selected" value="">Vermittlernummer</option>
          <option v-for="(option, index) in vermittlernummern" :key="index" :value="option">
            {{ option }}
          </option>
        </select>
      </p>

      <h2>Makler-Link</h2>

      <p>
        <label for="vermittlerId">Vermittler-Id</label>&nbsp;
        <input type="text" id="vermittlerId" v-model="vermittlerId" />
      </p>
      <p>
        <label for="externeReferenz">Externe Referenz</label>&nbsp;
        <input type="text" id="externeReferenz" v-model="externeReferenz" />
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-wrap: wrap;
  padding: 2rem;

  .cookies {
    margin: 1rem;
    width: 42rem;
    height: 30rem;
    border: #4c4c4c solid 1px;

    h1 {
      margin-top: 0;
      color: white;
      background-color: #0f5582;
      padding-left: 0.5rem;
      font-size: 1.5rem;
    }

    h2 {
      padding-left: 0.5rem;
      font-size: 1.25rem;
      font-weight: bold;
    }

    p,
    button {
      margin-left: 2rem;
    }
  }

  .item {
    width: 20rem;
    height: 11rem;
    margin: 1rem;
    border: #4c4c4c solid 1px;

    h1 {
      margin-top: 0;
      color: white;
      background-color: #599f7c;
      padding-left: 0.5rem;
      font-size: 1.5rem;
    }

    a {
      color: #0f5582;
    }
  }
}
</style>
